export default __webpack_public_path__ + "static/media/gallery_00.22b26c53.jpg";